// src/lib/permissions.ts -- Slice K / Phase 3.
//
// Centralised permission keys for the Info Hub. Each key is a string
// constant so consumers can refer to permissions without hardcoding the
// "can_post_headlines" / "is_news_admin" implementation detail.
//
// `headlines.post` -- the new Slice K permission. Granted to admins
// implicitly; granted to non-admin users by toggling `is_news_admin` on
// their hub_contacts row (the existing admin user editor already exposes
// this as the "News admin" checkbox -- Slice K reuses it rather than
// adding a fresh column, which keeps migration 026 to the headlines
// tables only). Backend gate in api/src/resources/headlines.ts mirrors
// this derivation.

import type { MeResponse } from "../auth";

export type PermissionKey = "headlines.post";

export const PERMISSION_KEYS: ReadonlyArray<PermissionKey> = ["headlines.post"];

/** True if the signed-in user can post Headlines (admin or news admin). */
export function canPostHeadlines(me: MeResponse | null): boolean {
  if (!me) return false;
  return me.isAdmin || me.isNewsAdmin;
}

/** Generic dispatch -- handy for future permission keys. */
export function hasPermission(me: MeResponse | null, key: PermissionKey): boolean {
  switch (key) {
    case "headlines.post": return canPostHeadlines(me);
  }
}
